/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Company_Meta_DescriptionInputs */

const ja_playdata_company_meta_description = /** @type {(inputs: Playdata_Company_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYDATA（プレイデータ）の会社概要のページです。`)
};

const en_playdata_company_meta_description = /** @type {(inputs: Playdata_Company_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company details for PLAYBRAIN Inc., which operates PLAYDATA.`)
};

/**
* | output |
* | --- |
* | "Company details for PLAYBRAIN Inc., which operates PLAYDATA." |
*
* @param {Playdata_Company_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_company_meta_description = /** @type {((inputs?: Playdata_Company_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Company_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_company_meta_description(inputs)
	return en_playdata_company_meta_description(inputs)
});